
// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";
import rgba from "../../functions/rgba";

const { primary,background,secondary } = colors;
const { md } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius,

    },

  },
};

export default tableContainer;
